export default "__VITE_ASSET__ShDAutxy__"